import api from './api.js';
import jWeixin from './jssdk_1.6.0.js';

const wx = {
    isWechat: function () {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/micromessenger/i) == 'micromessenger') {
            return true;
        } else {
            return false;
        }
    },
    initJssdkShare: async function (fn) {
        let res = await api({
            method:'post',
            // url: "/api/wx/js/sdk/config?url=" + window.location.href.split("#")[0],
            url:"/api/wechat/js/ticket?url=" + window.location.href.split("#")[0],
            data: {},
        });
        if (res.code == 0) {
            let { appId, nonceStr, rawString, signature, timestamp, url } =
                res.data;
            jWeixin.config({
                debug: true,
                appId,
                timestamp,
                nonceStr,
                signature,
                jsApiList: [
                    "chooseWXPay",
                    'onMenuShareTimeline', // 分享到朋友圈
                    'onMenuShareAppMessage', // 分享给朋友
                ],
            });
            jWeixin.ready(function (res) {
                console.log(res, "wx config");
            });
            if (fn) {
                fn();
            }
        }
    },
    pay: function (data) {
        jWeixin.chooseWXPay({
            timestamp: data.timeStamp,
            nonceStr: data.nonceStr,
            package: data.package,
            signType: data.signType,
            paySign: data.paySign,
            success: function (res) {
                this.$toast({
                    title: "支付成功",
                    icon: "none",
                });
                setTimeout(() => {
                    this.$store.dispatch("jump", {
                        path: "/pages/user/purchased",
                        params: "",
                    });
                });
            },
            fail: function (res) {
                this.$toast({
                    title: "支付失败" + JSON.stringify(res),
                    icon: "none",
                });
            },
            cancel: function (res) {
                this.$toast({
                    title: "支付取消" + JSON.stringify(res),
                    icon: "none",
                });
            },
        });
    },
    share: function (data, url) {
       
        url = url ? url : window.location.href;
        if (!this.isWechat()) {
            return;
        }
        this.initJssdkShare(function (signData) {
            jWeixin.ready(function () {
                var shareData = {
                    title: data && data.title ? data.title : signData.site_name,
                    desc: data && data.desc ? data.desc : signData.site_description,
                    link: url,
                    imgUrl: data && data.img ? data.img : signData.site_logo,
                    success: function (res) {
                    },
                    cancel: function (res) { }
                };
                jWeixin.updateAppMessageShareData(shareData);
                // jWeixin.onMenuShareTimeline(shareData);
            });
        }, url);
    },
    share2(data,url){
        console.log('jWeixin')
        console.log(jWeixin)
        url = url ? url : window.location.href;
        jWeixin.onMenuShareAppMessage({
            title: data.title || '标题', // 分享标题
            desc: data.desc || '描述', // 分享描述
            link: url, // 分享链接
            imgUrl: data.imgUrl || '', // 分享图标
            success:  ()=> {
            },
            cancel:  ()=> {
            }
          })
        
        // console.log('jWeixin')
        // console.log(jWeixin)
        // jWeixin.ready(function () {
        //     var shareData = {
        //         title: data && data.title ? data.title : signData.site_name,
        //         desc: data && data.desc ? data.desc : signData.site_description,
        //         link: url,
        //         imgUrl: data && data.img ? data.img : signData.site_logo,
        //         success: function (res) {
        //         },
        //         cancel: function (res) { }
        //     };
        //     jWeixin.onMenuShareAppMessage(shareData);
        //     jWeixin.onMenuShareTimeline(shareData);
        // });
    }
}

export default wx;